import React, { useCallback } from "react";
import { GlobalBox } from 'components/Box/GlobalBox'
import { useSelector, useDispatch } from "react-redux";
import { useSearch } from "hooks/useSearch";
import PublicIcon from '@mui/icons-material/Public';
import { TableInputs } from "components/CardTable/TableInputs"
import { dateValidator } from "helpers/dateValidator";
import { newDate } from "helpers/dateTools";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { setReportGlobalSalesFilters, getReportGlobalSalesAction } from "redux/actions/Reports/reportGlobalSales/reportGlobalSalesActions";

export const ReportGlobalSalesView = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { startDate, endDate, station } = useSelector(({ reportGlobalSales }) => reportGlobalSales);

  const handleSubmit = useCallback((e, isPdf = true) => {
    e.preventDefault()
    if (dateValidator(startDate, endDate, 31, setSnackbar)) return
    dispatch(getReportGlobalSalesAction({ startDate, endDate, station, isPdf }))
  }, [startDate, endDate, station]);

  return (
    <GlobalBox title="Reporte de Venta Global" icon={<PublicIcon />} >
      {isLoadingComp?.loadingReportGlobalSales ? <LoadingComponent /> :
        <TableInputs
          reducer="reportGlobalSales"
          dates
          stations
          maxDate={newDate()}
          dispatchAction={setReportGlobalSalesFilters}
          submitAction={handleSubmit}
          submitButtonName="PDF"
          submitSecond={(e) => handleSubmit(e, false)}
        />
      }
    </GlobalBox>
  );
};
